<template>
	<div :style="{direction: $vs.rtl ? 'rtl' : 'ltr'}">
		<feather-icon
			icon="Edit2Icon"
			svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
			class="g-label--normal"
			@click="editRecord"
		/>
		<feather-icon
			icon="Trash2Icon"
			svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
			class="g-label--normal"
			@click="confirmDeleteRecord"
		/>
	</div>
</template>

<script>
export default {
	name: "CellRendererActions",
	methods: {
		removeEvent() {
			const {id, resource_id} = {...this.params.data};
			const obj = {
				events: [{event_id: id, resource_id}],
			};

			this.$store
				.dispatch("moduleSchedule/cancelEvent", obj)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmEventDelete"),
						text: this.$t("TextConfirmEventDelete"),
					});
				})
				.catch((err) => {
					this.showErrorAlert();
				});
		},
		editRecord() {
			//this.$router.push(`/apps/user/user-edit/${  268}`).catch(() => {})
			this.$router.push({
				name: "resource-calendar",
				params: {id: this.params.data.resource_id},
			});

			/*
                    Below line will be for actual product
                    Currently it's commented due to demo purpose - Above url is for demo purpose

                    this.$router.push("/apps/user/user-edit/" + this.params.data.id).catch(() => {})
                  */
		},
		confirmDeleteRecord() {
			this.$emit("emitEvent");
			if (this.params.data.event_status_id === 2 || this.params.data.event_status_id === 3) {
				this.$vs.dialog({
					type: "confirm",
					color: "danger",
					title: this.$t("Confirm"),
					text: `${this.$t("Resource.List.CellRenderer.DeleteRecord")}: ${this.params.data.activity_name} - ${
						this.params.data.date_prog
					} ${this.params.data.init_hour} `,
					accept: this.deleteRecord,
					acceptText: this.$t("Crud.Delete"),
					cancelText: this.$t("Cancel"),
				});
			}
		},
		deleteRecord() {
			/* Below two lines are just for demo purpose */
			this.removeEvent();
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("Object.UserDeleted.Title"),
				text: this.$t("Object.UserDeleted.Text"),
			});
		},
	},
};
</script>
